import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'get',
})
export class GetByCallbackPipe implements PipeTransform {
  transform<T, R, A>(value: T, cb: (value: T, ...args: A[]) => R, ...args: A[]): R {
    return cb(value, ...args);
  }
}
